export default {
  titles: {
    1: '¿Qué contenido has utilizado?',
    2: 'Más información sobre el uso'
  },
  next: 'Siguiente',
  prev: 'Volver',
  submit: 'Enviar',
  success: '¡Has registrado con éxito el uso del contenido!',
  useForm: {
    schoolLabel: 'Selecciona una escuela',
    schoolPlaceholder: 'Selecciona una escuela',
    courseLabel: 'Selecciona un curso',
    dateLabel: 'Selecciona un mes y un año',
    coursePlaceholder: 'Seleccionar',
    datePlaceholder: 'Seleccionar',
    experienceLabel: 'Comparte tu experiencia',
    experiencePlaceholder: 'Comparte con otros docentes de tu red cómo fue tu experiencia utilizando este contenido en clase.'
  },
  contentList: {
    class: 'Clase {classNumber}',
    classWithName: 'Clase {classNumber}: {name}'
  }
}

export const en = {
  titles: {
    1: 'What content have you used?',
    2: 'More information on the usage'
  },
  next: 'Next',
  prev: 'Back',
  submit: 'Send',
  success: 'You have successfully registered the use of the content!',
  useForm: {
    schoolLabel: 'Select a school',
    schoolPlaceholder: 'Select a school',
    courseLabel: 'Select a course',
    dateLabel: 'Select a month and a year',
    coursePlaceholder: 'Select',
    datePlaceholder: 'Select',
    experienceLabel: 'Share your experience',
    experiencePlaceholder: 'Share with other teachers in your network how was your experience using this content in class.'
  },
  contentList: {
    class: 'Class {classNumber}',
    classWithName: 'Class {classNumber}: {name}'
  }
}

export const ca = {
  titles: {
    1: 'Quin contingut has fet servir?',
    2: 'Més informació sobre l\'ús'
  },
  next: 'Següent',
  prev: 'Torna',
  submit: 'Envia',
  success: 'Has enregistrat amb èxit l\'ús del contingut!',
  useForm: {
    schoolLabel: 'Selecciona una escola',
    schoolPlaceholder: 'Selecciona una escola',
    courseLabel: 'Selecciona un curs',
    dateLabel: 'Selecciona un mes i un any',
    coursePlaceholder: 'Seleccionar',
    datePlaceholder: 'Seleccionar',
    experienceLabel: 'Comparteix la teva experiència',
    experiencePlaceholder: 'Comparteix amb altres docents de la teva xarxa com ha estat la teva experiència fent servir aquest contingut a classe.'
  },
  contentList: {
    class: 'Classe {classNumber}',
    classWithName: 'Classe {classNumber}: {name}'
  }
}
